import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { font, color } = baseVariables;

export const StyledRecentListDiv = styled.div`
  h3 {
    line-height: ${toRem(14)};
    text-transform: capitalize;
    font-weight: ${font.fontWeightNormal};
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    .list-item {
      padding: ${toRem(8)};
      border-radius: ${toRem(8)};
      &:hover {
        background-color: ${color.neutral10};
      }
      a {
        display: flex;
        gap: ${toRem(8)};
        align-items: center;
        text-decoration: none;
        line-height: ${toRem(20)};
        span {
          position: relative;
        }
      }
    }
  }
  .flyout-icon {
    background: ${color.neutral10};
    padding: ${toRem(8)};
    border-radius: ${toRem(4)};
  }
`;
